import "office-ui-fabric-react/dist/css/fabric.min.css";
import App from "./components/App";
import { AppContainer } from "react-hot-loader";
import { initializeIcons } from "office-ui-fabric-react/lib/Icons";
import * as React from "react";
import * as ReactDOM from "react-dom";
import { Authenticator } from "@microsoft/office-js-helpers";

initializeIcons();

let isOfficeInitialized = false;

const title = "Odoo for Outlook";

const render = Component => {
  ReactDOM.render(
    <AppContainer>
      <Component title={title} isOfficeInitialized={isOfficeInitialized} itemChangedRegister={itemChangedRegister} />
    </AppContainer>,
    document.getElementById("container")
  );
};

let itemChangedHandler: (type: Office.EventType) => void;
const itemChangedRegister = (f: (type: Office.EventType) => void) => {
  itemChangedHandler = f;
};

let initTimer: any = null;
let initFired = false;

function completeOfficeInit() {
  if (initFired) return;
  initFired = true;
  if (initTimer) {
    clearTimeout(initTimer);
    initTimer = null;
  }

  if (Authenticator.isAuthDialog()) return;

  try {
    isOfficeInitialized = true;
    if (Office?.context?.mailbox?.addHandlerAsync) {
      Office.context.mailbox.addHandlerAsync(Office.EventType.ItemChanged, itemChangedHandler);
    }
  } catch (e) {
    console.warn("addHandlerAsync failed, continuing without ItemChanged handler", e);
  }
  render(App);
}

/* Render application after Office initializes */
if (typeof Office !== "undefined") {
  const modernInit = (Office as any).onReady;
  if (typeof modernInit === "function") {
    modernInit(completeOfficeInit);
  }
  // Fallback to legacy Office.initialize assignment
  Office.initialize = completeOfficeInit;

  // Defensive timeout: if Office.initialize/onReady never fires, force init
  // so the user doesn't get stuck on a blank / spinner page
  initTimer = setTimeout(() => {
    if (!initFired) {
      console.warn("Office.initialize/onReady did not fire within 5s, forcing init");
      completeOfficeInit();
    }
  }, 5000);
} else {
  // Office.js not available - running outside Office context
  console.warn("Office.js not available - running outside Office context");
  isOfficeInitialized = false;
  render(App);
}

/* Initial render showing a progress bar */
render(App);

if ((module as any).hot) {
  (module as any).hot.accept("./components/App", () => {
    const NextApp = require("./components/App").default;
    render(NextApp);
  });
}
